import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import Alliance from "@/pages/Alliance";
import Manifesto from "@/pages/Manifesto";
import Research from "@/pages/Research";
import ResearchCompendium from "@/pages/ResearchCompendium";
import BeyondScienceSeries from "@/pages/BeyondScienceSeries";
import BookDetail from "@/pages/BookDetail";
import Founder from "@/pages/Founder";
import FoundingMembers from "@/pages/FoundingMembers";
import Programs from "@/pages/Programs";
import Engage from "@/pages/Engage";
import MemberFormRedirect from "@/pages/MemberFormRedirect";
import Media from "@/pages/Media";
import Legal from "@/pages/Legal";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminSchemaEditor from "@/pages/admin/AdminSchemaEditor";
import AdminSubmissions from "@/pages/admin/AdminSubmissions";
import AdminAssets from "@/pages/admin/AdminAssets";

function App() {
  useEffect(() => {
    document.documentElement.lang = "en";
  }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" />
          <Routes>
            {/* Public site */}
            <Route path="/" element={<Home />} />
            <Route path="/alliance" element={<Alliance />} />
            <Route path="/manifesto" element={<Manifesto />} />
            <Route path="/research" element={<Research />} />
            <Route path="/research-compendium" element={<ResearchCompendium />} />
            <Route path="/beyond-science" element={<BeyondScienceSeries />} />
            <Route path="/beyond-science/:slug" element={<BookDetail />} />
            <Route path="/founder" element={<Founder />} />
            <Route path="/founding-members" element={<FoundingMembers />} />
            <Route path="/programs" element={<Programs />} />
            <Route path="/engage" element={<Engage />} />
            <Route path="/join-bsca" element={<Navigate to="/engage#join" replace />} />
            <Route path="/memberform" element={<MemberFormRedirect />} />
            <Route path="/memberform/" element={<MemberFormRedirect />} />
            <Route path="/submit-contribution" element={<Navigate to="/engage#contribution" replace />} />
            <Route path="/contact" element={<Navigate to="/engage#contact" replace />} />
            <Route path="/media" element={<Media />} />
            <Route path="/privacy-policy" element={<Legal />} />
            <Route path="/terms-of-use" element={<Legal />} />

            {/* Admin */}
            <Route path="/admin" element={<AdminLogin />} />
            <Route element={<AdminLayout />}>
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/admin/submissions" element={<AdminSubmissions />} />
              <Route path="/admin/assets" element={<AdminAssets />} />
              <Route path="/admin/c/:name" element={<AdminSchemaEditor />} />
            </Route>

            {/* Catch-all */}
            <Route path="*" element={<Home />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
